"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetTestIds = void 0;
var QuizIntroMethods = _interopRequireWildcard(require("./QuizIntro"));
var _ContentContainer = _interopRequireDefault(require("../ContentContainer/ContentContainer"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuizProvider = require("./QuizProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _scroll = require("../../utils/scroll");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  GetTestIds = testId => ({
    component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
    actions: (0, _string.isStringOfLength)(testId) ? `${testId}_actions` : undefined,
    title: (0, _string.isStringOfLength)(testId) ? `${testId}_title` : undefined
  });

/**
 * Quiz Intro View Component
 *
 * @visibleName Quiz Intro
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.GetTestIds = GetTestIds;
const QuizIntro = props => {
  const {
      buttonText = "Take Quiz",
      buttonVariant = "primary",
      children,
      className,
      customActions,
      customTheme = {},
      fragmentId,
      hideActions = false,
      hideButton = false,
      onClick,
      styles = {},
      testId,
      title,
      titleClassName,
      titleTag = "h3"
    } = props,
    quizTheme = _QuizProvider.Methods.useCustomTheme(),
    theme = merge.all([(0, _styles.useTheme)(), quizTheme, customTheme]),
    state = _QuizProvider.Methods.useState(),
    dispatch = _QuizProvider.Methods.useDispatch(),
    customClasses = (0, _classnames.default)({
      "quiz__intro": true,
      "interiorContentIntro": true,
      [`${className}`]: className
    }),
    customStyles = merge({
      ".quiz__intro-actions": {
        marginTop: "5rem"
      }
    }, styles),
    customHeaderClasses = (0, _classnames.default)({
      "quiz__intro-heading": true,
      "heading--isInteriorPageSubHeading": true,
      [`${titleClassName}`]: titleClassName
    }),
    testIdObject = (0, _react.useMemo)(() => QuizIntroMethods.GetTestIds(testId), [testId]),
    introRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(() => {
    if (state.isReset) {
      (0, _scroll.scrollToElement)(introRef.current);
      dispatch({
        type: "toggleReset"
      });
    }
  }, [dispatch, introRef, state.isReset]);
  return /*#__PURE__*/_react.default.createElement(_ContentContainer.default, {
    className: customClasses,
    customTheme: theme,
    styles: customStyles,
    testId: testIdObject.component
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: introRef
  }, (0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: titleTag,
    className: customHeaderClasses,
    "data-testid": testIdObject.title
  }, title), title && !(0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    className: customHeaderClasses,
    "data-testid": testIdObject.title
  }, title), (0, _string.isStringOfLength)(fragmentId) && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children, !hideActions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__intro-actions",
    component: "div",
    "data-testid": testIdObject.actions
  }, !hideButton && /*#__PURE__*/_react.default.createElement(_material.Button, {
    type: "button",
    className: "quiz__intro-button",
    variant: buttonVariant,
    onClick: onClick
  }, buttonText), customActions)));
};

// Define propTypes;
QuizIntro.propTypes = {
  /** Text for Quiz Intro Button (Default Value: "Take Quiz") */
  buttonText: _propTypes.default.string,
  /** Button variant (Default Value: "primary") */
  buttonVariant: _propTypes.default.string,
  /** Child Nodes, before after content fragment */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Classname for component */
  className: _propTypes.default.string,
  /** Custom Actions Component */
  customActions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom Theme object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** String id of fragment for intro text */
  fragmentId: _propTypes.default.string,
  /** Boolean to hide default action block (Default Value: false) */
  hideActions: _propTypes.default.bool,
  /** Boolean to hide default action button (Default Value: false) */
  hideButton: _propTypes.default.bool,
  /** Function to toggle modal */
  onClick: _propTypes.default.func.isRequired,
  /** Styles for component (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Results title */
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Classnames for title */
  titleClassName: _propTypes.default.string,
  /** Tag for rendering title (Default Value: "h3") */
  titleTag: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = QuizIntro;